
import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';

export const notificationsStylePhone = StyleSheet.create({
  container: {
    flex: 1,
  },
  image: {
    width: '100%',
    height: '90%',
    resizeMode: 'contain',
    padding: 10
  },
  button: {
    flex: 1,
    maxWidth: 500,
    minWidth: 300,
    marginLeft: 'auto',
    marginRight: 'auto',
    bottom: Device.isTablet ? 30 : 0,
  },
  imageBackgroundStyle: {
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    position: 'absolute'
  },
  contentImageContainer: { paddingTop: 60 }
});


export const notificationsStyleWeb = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imagesContainer: {
    width: '60%',
    height: '60%',
  },
  contentImageContainer: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 'auto'
  },
  backgroundImage: {
    flex: 1,
    width: '100%',
    height: '100%',
    resizeMode: 'contain',
    margin: 50
  },
  buttonContainer: {
    marginTop: 20,
    width: '70%',
    alignItems: 'center',
  },
  button: {
    maxWidth: 500,
    minWidth: 300,
  },
});

